module.exports = __webpack_public_path__ + "static/media/left-arrow.4f24da88.svg";